import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  MultiMetricComparisonVizData,
  MultiMetricComparisonVizExternalProps,
} from '../../types';
import { multiMetricComparisonBarChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  MultiMetricComparisonBarChartActions,
  MultiMetricComparisonBarChartState,
  MultiMetricComparisonBarChartUiComponentProps,
} from './types';
import { MultiMetricComparisonBarChartUiComponent } from './UiComponent';
import { useMultiMetricComparisonBarChartStateManager } from './useStateManager';

export const multiMetricComparisonBarChartViewConfig: DataVizContainerViewConfigWithStateManager<
  MultiMetricComparisonVizData,
  MultiMetricComparisonVizExternalProps,
  MultiMetricComparisonBarChartUiComponentProps,
  MultiMetricComparisonBarChartState,
  MultiMetricComparisonBarChartActions
> = {
  hasStateManager: true,
  useStateManager: useMultiMetricComparisonBarChartStateManager,
  dataToUiComponentProps: multiMetricComparisonBarChartDataToUiComponentProps,
  UiComponent: MultiMetricComparisonBarChartUiComponent,
};
